import { forwardRef } from "react";

import { useSetting } from "metabase/settings";
import { Box, type BoxProps } from "metabase/ui";
import metabotMarkUrl from "assets/img/metabot-96x96.svg";

export interface MetabotIconProps extends BoxProps {
  size?: number;
}

/**
 * Renders the metabot icon — either the default built-in SVG icon
 * or a custom uploaded image from the "metabot-icon" setting.
 */
export const MetabotIcon = forwardRef<HTMLImageElement, MetabotIconProps>(
  function MetabotIcon({ size = 16, ...rest }, ref) {
    const metabotIcon = useSetting("metabot-icon");
    const metabotName = useSetting("metabot-name");

    const isCustomIcon = metabotIcon && metabotIcon !== "metabot";

    if (isCustomIcon) {
      return (
        <Box
          component="img"
          ref={ref}
          src={metabotIcon}
          alt={metabotName}
          w={size}
          h={size}
          style={{ objectFit: "contain" }}
          {...rest}
        />
      );
    }

    // ponytail: Nubrix Bot mark served from the static asset
    // (resources frontend_client/app/assets/img/metabot-96x96.svg).
    return (
      <Box
        component="img"
        ref={ref}
        src={metabotMarkUrl}
        alt={metabotName}
        w={size}
        h={size}
        style={{ objectFit: "contain" }}
        {...rest}
      />
    );
  },
);
